import axios from "axios";
import ConsoleHelper from "../utils/logger";
import storeService from "./storage";
import * as config from "./config";

export const axiosInstance = axios.create();

axiosInstance.interceptors.request.use((x) => {
  ConsoleHelper(x);
  return x;
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    return new Promise((resolve, reject) => {
      const originalReq = err.config;
      if (
        err.response.status === 409 &&
        err.config &&
        !err.config.__isRetryRequest
      ) {
        originalReq._isRetryRequest = true;
        const Jwt = storeService.getString("jwt");
        let res = fetch(`${config.baseUrl}/auth/refresh`, {
          method: "GET",
          headers: { Jwt },
          mode: "cors",
          credentials: "include",
        })
          .then((res) => res.json())
          .then((resJson) => {
            ConsoleHelper("refresh-response json-data:");
            ConsoleHelper(resJson);
            storeService.storeString("jwt", resJson.data.jwt);
            return axios(originalReq);
          });
        resolve(res);
      }
      return reject(err);
    });
  }
);
